<template>
  <div class="categoryName">
    工业企业
  </div>
</template>
<script>
export default {
  props: ['categoryName']
}
</script>
<style lang="scss">
.categoryName{
  height: 121px;
  line-height: 121px;
  color:#67ebc3;
  font-size: 60px;
  font-weight: 700;
  letter-spacing: 10px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/categoryName/generateEnterprises.vue